import { useEffect } from 'react';
/**
 * S-91 第2弾: Speculation Rules API による遷移先 prerender。
 *
 * `<script type="speculationrules">` を head に注入し、hover（eagerness: moderate）で
 * 対象 URL を裏で完全起動（JS 実行・Firebase Auth 復元・初回データ取得まで）させる。
 * クリック時は描画済みページへの切替になり体感ほぼゼロ秒。
 *
 * 前提と制約:
 * - prerender は same-site cross-origin のみ（TP-33 の tracepit.jp サブドメイン統一が前提。
 *   cross-site の URL は候補として無効になるだけで無害）
 * - 遷移先レスポンスに `Supports-Loading-Mode: credentialed-prerender`（firebase.json で付与）
 * - URL は fragment 込み完全一致で activate されるため、素リンク遷移（S-91 第2弾）の
 *   URL だけを渡すこと（`selectPrerenderUrls`）
 * - Chromium 系のみ対応。非対応ブラウザでは `HTMLScriptElement.supports` 判定で no-op
 */
export function SpeculationPrerender({ urls }) {
    // 配列の identity ではなく内容で effect を張り直す（render ごとの再注入を防ぐ）。
    const urlsKey = JSON.stringify(urls);
    useEffect(() => {
        if (urls.length === 0)
            return;
        if (typeof HTMLScriptElement === 'undefined' ||
            typeof HTMLScriptElement.supports !== 'function' ||
            !HTMLScriptElement.supports('speculationrules')) {
            return;
        }
        const script = document.createElement('script');
        script.type = 'speculationrules';
        script.textContent = JSON.stringify({
            prerender: [{ urls: [...urls], eagerness: 'moderate' }],
        });
        document.head.append(script);
        return () => {
            script.remove();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [urlsKey]);
    return null;
}
//# sourceMappingURL=SpeculationPrerender.js.map